module.exports = __webpack_public_path__ + "static/media/numberOfPersonsIcon.b16db4be.svg";